exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3EkmE{position:absolute;top:0;left:0;right:0;bottom:0;visibility:hidden;z-index:131}._3EkmE._3ilzP{visibility:visible}.dXrLx{height:100%;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration}", ""]);

// exports
exports.locals = {
	"wrapper": "_3EkmE",
	"active": "_3ilzP",
	"content": "dXrLx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/styles.styl
// module id = 1445
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact